<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Shift
    </button>
    <a-modal v-model="visible" title="Add a new shift">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Add Shift</a-button>
      </template>

      <a-form class="mb-4" :form="form">
         <a-form-item label="Name">
          <a-input v-decorator="['name', { rules: [{ required: true, message: 'Please enter name' }] }]" />
        </a-form-item>

        <a-form-item label="Code">
          <a-input v-decorator="['code', { rules: [{ required: true, message: 'Please enter code' }] }]" />
        </a-form-item>

        <a-form-item label="Description">
          <a-input v-decorator="['description']" />
        </a-form-item>

        <a-row :gutter="16">
        <a-col :span="12">
        <a-form-item label="Start Time">
        <a-time-picker format="HH:mm:ss"  style="width: 230px" v-decorator="['start_time', { rules: [{ required: true, message: 'Please select start time' }] }]" />
        </a-form-item>
        </a-col>

        <a-col :span="12">
        <a-form-item label="End Time">
        <a-time-picker format="HH:mm:ss"  style="width: 230px" v-decorator="['end_time', { rules: [{ required: true, message: 'Please select end time' }] }]" />
        </a-form-item>
        </a-col>
        </a-row>

        <a-row :gutter="16">
         <a-col :span="12">
         <a-form-item label="Break Start">
         <a-time-picker format="HH:mm:ss"  style="width: 230px" v-decorator="['break_start',{rules: [{ required: false, message: 'Please select break start' }]}]" />
         </a-form-item>
         </a-col>
        <a-col :span="12">

        <a-form-item label="Break End">
        <a-time-picker format="HH:mm:ss"  style="width: 230px" v-decorator="['break_end',{rules: [{ required: false, message: 'Please select break end' }]}]" />
        </a-form-item>
        </a-col>
        </a-row>

        <a-form-item label="Default">
        <a-select v-decorator="['is_default', { initialValue: 0 }]">
        <a-select-option :value="1">Yes</a-select-option>
        <a-select-option :value="0">No</a-select-option>
        </a-select>
        </a-form-item>

        <a-form-item label="Status">
          <a-select v-decorator="['status', { initialValue: 1 }]">
            <a-select-option :value="1">Active</a-select-option>
            <a-select-option :value="0">Inactive</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { Row, Col } from 'ant-design-vue'

export default {
  name: 'AddShift',
  components: {
    'a-row': Row,
    'a-col': Col,
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },
    toHHmmss(val) {
    // handles both Moment objects and strings
      if (!val) return null
      return typeof val.format === 'function' ? val.format('HH:mm:ss') : String(val)
    },

    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          const startTime = this.toHHmmss(values.start_time || null)
          const endTime = this.toHHmmss(values.end_time || null)
          const breakStart = this.toHHmmss(values.break_start || null)
          const breakEnd = this.toHHmmss(values.break_end || null)
          this.$confirm({
            title: `Are you sure you want to add ${values.name}?`,
            content: `Click on the OK button to add the new class!`,
            onOk: () => {
              this.$http
                .post('/api/attendance-shift/single', {
                  name: values.name,
                  code: values.code,
                  description: values.description,
                  start_time: startTime,
                  break_start: breakStart,
                  break_end: breakEnd,
                  end_time: endTime,
                  is_default: values.is_default,
                  status: values.status,
                })
                .then(({ data }) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Shift successfully added',
                    description: `${data.name} added successfully!`,
                  })
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
    },
  },
}
</script>
